import type { CardSetupIntent, PublicCardCheckoutResponse } from "@pkg/sdk/models";
import type { Connection } from "penpal";
import { connectToWindow } from ".";

type CardIFrameMethods = {
  onSubmit: (cardSetupIntentId: string) => Promise<CardSetupIntent | { error: CardErrorCode }>;
  onValidate: () => Promise<CardErrorCode | undefined>;
};

type CardParentMethods = {
  onLoaded: () => void;
  onFocusChange: (isFocused: boolean) => void;
};

export type CardInputType = "card_pan" | "card_exp" | "card_cvc";

export type CardErrorCode =
  | "invalid"
  | "required"
  | "unknown_error"
  | "penpal_not_connected"
  | "missing_checkout_token";

export type IFrameConnection = Connection<CardIFrameMethods>;

export type ParentConnection = Connection<CardParentMethods>;

export type CheckoutResponse = PublicCardCheckoutResponse;

export const connectToCardIframe = (iframe: HTMLIFrameElement, methods: CardParentMethods) => {
  return connectToWindow<CardIFrameMethods>({ window: iframe.contentWindow as Window, methods });
};

export const connectToCardParent = (methods: CardIFrameMethods) => {
  return connectToWindow<CardParentMethods>({ window: window.parent, methods });
};
